import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import AbstractCheckErrorSignupScreen from './AbstractCheckErrorSignupScreen';

export default class EmailCheck500SignupScreen extends AbstractCheckErrorSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-email-check-500';

  public predicate(): boolean {
    const { emailCheckCode } = this.sessionInfo.value;
    if (emailCheckCode !== 500) {
      return false;
    }
    return true;
  }
}
